import styled, { css } from 'styled-components';

import { Typography } from '@mixins';

export const Contact = styled(Typography)`
  ${() => css`
    text-decoration: none;
  `}
`;
